import Vue from "vue";
import { Slide } from "vue-carousel";
import slugify from "slugify";
import once from "lodash/once";

import Carousel from "../../components/core/Carousel";
import LiveaboardCabins from "../../views/liveaboard/LiveaboardCabins";
import LiveaboardGuestPicker from "../../views/liveaboard/LiveaboardGuestPicker";
import LiveaboardTrips from "../../views/liveaboard/LiveaboardTrips";
import ReviewSection from "../../components/ProductDetail/Review";
import ZbModal from "../../components/core/ZbModal";
import FooterNav from "../../components/Liveaboard/FooterNav";
import Responsive from "../../components/core/Responsive";
import LiveaboardFacilities from "../../views/liveaboard/LiveaboardFacilities";
import LiveaboardFacilitiesMobile from "../../views/liveaboard/LiveaboardFacilitiesMobile";
import DiveCenterFacilitiesMobile from "../../views/liveaboard/DiveCenterFacilitiesMobile";
import DiveCenterFacilities from "../../views/liveaboard/DiveCenterFacilities";
import BookingTermModal from "../../views/liveaboard/BookingTermModal";
import LiveaboardSidebar from "../../views/liveaboard/LiveaboardSidebar";
import ProductHeading from "../../components/ProductDetail/Heading";
import FeaturedReview from "../../components/FeaturedReview";
import GreenFinMembership from "../../components/Resort/GreenFinMembership";
import AwardBadge from "../../components/Resort/AwardBadge";
import CurrencyContext from "../../components/core/CurrencyContext";
import ResortFAQs from "../../components/Resort/ResortFAQs";

Vue.filter("formatPrice", (rawPrice) => {
  return rawPrice.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
});
Vue.component("carousel", Carousel);
Vue.component("v-slide", Slide);
Vue.component("liveaboard-cabins", LiveaboardCabins);
Vue.component("liveaboard-guest-picker", LiveaboardGuestPicker);
Vue.component("liveaboard-trips", LiveaboardTrips);
Vue.component("zb-modal", ZbModal);
Vue.component("footer-nav", FooterNav);
Vue.component("responsive", Responsive);
Vue.component("liveaboard-facilities", LiveaboardFacilities);
Vue.component("liveaboard-facilities-mobile", LiveaboardFacilitiesMobile);
Vue.component("dive-center-facilities-mobile", DiveCenterFacilitiesMobile);
Vue.component("dive-center-facilities", DiveCenterFacilities);
Vue.component("booking-term-modal", BookingTermModal);
Vue.component("review-section", ReviewSection);
Vue.component("product-heading", ProductHeading);
Vue.component("liveaboard-sidebar", LiveaboardSidebar);
Vue.component("featured-review", FeaturedReview);
Vue.component("green-fin-membership", GreenFinMembership);
Vue.component("award-badge", AwardBadge);
Vue.component("currency-context", CurrencyContext);
Vue.component("resort-faqs", ResortFAQs);

window.fetchSupplierInfo = once((supplierId) => {
  return new Promise((resolve, reject) => {
    $.get(
      `${window.ZUBLU_VARIABLES.ODYSSEY_API}/api/v1/supplier_info?supplier_id=${supplierId}`
    )
      .done((res) => {
        if (res === "No Supplier Found") {
          reject();
        } else {
          resolve(res);
        }
      })
      .fail(reject);
  });
});

$(document).ready(function () {
  initStickyNav();
});

function initStickyNav() {
  const stickyHeader = $(".resort-nav");

  const h2s = Array.from(document.querySelectorAll("h2[data-sticky-nav-item]"));
  const list = stickyHeader.find("ul");
  list.empty();

  let index = 0;
  for (const h2 of h2s) {
    const slug = slugify(h2.textContent);
    h2.id = slug;

    let hiddenClass = "";

    if (h2.classList.contains("data-sticky-nav-item-hidden")) {
      hiddenClass = "hidden";
    }

    let title = h2.textContent.trim();
    if (h2.textContent.trim() === "Frequently asked questions") {
      title = "FAQs";
    }

    list.append(`
      <li class="h-full mb-0">
        <a href="#${slug}" class="resort-nav-link outline-none font-medium ${hiddenClass} ${
      index === 0 ? "active" : ""
    }">
          ${title}
        </a>
      </li>
    `);

    index++;
  }

  stickyHeader.stickySidebar({
    topSpacing: 0,
    bottomSpacing: 50,
    containerSelector: ".sticky-nav-container",
    innerWrapperSelector: ".sidebar__inner",
  });

  stickyHeader
    .get(0)
    .addEventListener("affixed.top.stickySidebar", function () {
      $(".resort-nav").addClass("resort-nav--show");
    });

  stickyHeader
    .get(0)
    .addEventListener("affix.static.stickySidebar", function () {
      $(".resort-nav").removeClass("resort-nav--show");
    });

  $(".resort-nav").navpoints();

  $(".plan-trip-btn").click(() => {
    window.scrollToElement($("h2#Choose-your-trip"));
  });
}

window.initStickyNav = initStickyNav;

const apps = document.querySelectorAll(".vue-app");

Array.prototype.forEach.call(
  apps,
  (el) =>
    new Vue({
      el,
      template: el.innerHTML,
    })
);
